import React, { useState, useEffect } from "react";
import BathroomLeadPopup from "./BathroomLeadPopup";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showLeadPopup, setShowLeadPopup] = useState(false);

  useEffect(() => {
    const showButtonOnScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', showButtonOnScroll);
    return () => window.removeEventListener('scroll', showButtonOnScroll);
  }, []);

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-10 right-28 z-50 flex flex-col items-end">
          {/* Main CTA Button */}
          <button 
            onClick={() => setShowLeadPopup(true)}
            className="flex items-center bg-[#FF7A30] hover:bg-[#FF6A20] text-white font-bold py-3 px-5 rounded-full shadow-lg transition duration-300 mb-3 group animate-pulse"
          >
            <span className="mr-2">Get Free Quotes</span>
            <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
          </button>
          
          {/* Discount Badge */}
          <div className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-3 py-1 rounded-full border border-yellow-200 shadow-sm">
            Limited time: Save up to 40% today!
          </div>
        </div>
      )}
      
      {showLeadPopup && (
        <BathroomLeadPopup isOpen={showLeadPopup} onClose={() => setShowLeadPopup(false)} />
      )}
    </>
  );
};

export default FloatingCTA;
